import { Box, Button, Card, CardActions, CardHeader, Link, Skeleton } from "@mui/material";
import { useRootStore } from "../../hooks/useRootStore";
import { useEffect, useMemo, useState } from "react";
import moment from 'moment';
import momentDurationFormatSetup from "moment-duration-format";
momentDurationFormatSetup(moment);
import TrackingToggler from "../TrackingToggler";
import { Timesheet } from "../../data/Timesheet";
import TrackedTimeDialog from "../TrackedTimeDialog";
import { UserType } from "../../data/UserType";
import { EmployeeProfile } from "../../data/UserProfile";

export default function IssueTrackerWidget({ issueId, estimationHours }: { issueId: number, estimationHours: number | null | undefined }) {
    const { api, userProfile, timesheetsChannel } = useRootStore();
    const [timesheets, setTimesheets] = useState([] as Timesheet[]);
    const [loading, setLoading] = useState(true);
    const [timsheetsDialogOpen, setTimsheetsDialogOpen] = useState(false);

    useEffect(() => {
        api.getIssueTimesheets(issueId).then(timesheets => {
            setTimesheets(timesheets);
            setLoading(false);
        });
        if (estimationHours === undefined) {
            alert('TODO получить с бека');
        }
    }, [api, issueId, estimationHours, timesheetsChannel])

    useEffect(() => {
        const unsubscribeOnTimesheetAdded = timesheetsChannel.on('onTimesheetAdded', (timesheet: Timesheet) => {
            if (timesheet.IssueID == issueId) {
                setTimesheets([...timesheets, timesheet]);
            }
        })
        return () => unsubscribeOnTimesheetAdded();
    }, [issueId, timesheets, timesheetsChannel])

    const totalHours = useMemo(() => timesheets.reduce((total, a) => total + a.Hours, 0), [timesheets]);

    return (
        <>
            {timsheetsDialogOpen ? <TrackedTimeDialog issueId={issueId} onClose={() => setTimsheetsDialogOpen(false)} /> : ''}
            <Card className="issue-widget">
                <CardHeader title="Трекер" className="card-header" />
                {userProfile?.UserType != UserType.Employee || issueId != (userProfile as EmployeeProfile).ActiveIssueId ? '' : 
                    <Box sx={{ position: 'absolute', top: 0, right: 5 }}>
                        <TrackingToggler id={issueId} size={24} stopColor="red" playColor="#1976d2" />
                    </Box>
                }
                <Box>
                    {loading
                        ?
                        <Skeleton sx={{ width: '100%', height: '120px', m:0, p:0 }} height={180} />
                        :
                        <>
                            <Box>Запланировано, часов: {estimationHours}</Box>
                            <Box>Всего, часов: {moment.duration(totalHours * 60 * 60 * 1000).format("HH:mm", { trim: false })}</Box>
                            <Box>Последняя: {timesheets.length > 0 ? <Link href={`${document.URL.replace(/#.*$/, "")}#activity-timesheetRecord-${timesheets[0].ID}`}>{moment(timesheets[0].StopDate).format('DD.MM.YYYY') + ` (${moment.duration(timesheets[0].Hours * 60 * 60 * 1000).format("HH:mm", { trim: false })})`}</Link> : 'нет'}</Box>
                            {timesheets.length == 0 ? '' :
                                <CardActions sx={{ display: 'block', textAlign: 'center' }} >
                                    <Button size="small" onClick={() => setTimsheetsDialogOpen(true)}>Смотреть все</Button>
                                </CardActions>
                            }
                        </>
                    }
                </Box>
            </Card>
        </>
    )
}